import { RouteView } from '@/layouts';

const seriesRouter = {
  path: '/series',
  name: 'Series',
  redirect: '/series/list',
  component: RouteView,
  meta: {
    title: '系列管理',
    icon: 'iconintegral',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'SeriesList',
      component: () => import('@/views/series/List'),
      meta: {
        title: '系列列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'add',
      name: 'SeriesAdd',
      component: () => import('@/views/series/Add'),
      meta: {
        title: '系列添加',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'SeriesEditor',
      component: () => import('@/views/series/Editor'),
      meta: {
        title: '系列编辑',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default seriesRouter;
